import { Reducer } from "redux";

import { AuthPacketResponse } from "../models/api/Referral";
import { AuthPacketDispatchTypes } from "../models/dispatchTypes/Referral";
import { GetAuthPacketActionDispatchTypes } from "../constants/HomePage";

const initialState: AuthPacketResponse = {
  loading: false,
  response: null,
  error: null,
};

const GetAuthPacketReducer: Reducer<
  AuthPacketResponse,
  AuthPacketDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case GetAuthPacketActionDispatchTypes.GET_AUTH_PACKET_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case GetAuthPacketActionDispatchTypes.GET_AUTH_PACKET_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case GetAuthPacketActionDispatchTypes.GET_AUTH_PACKET_ERROR: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
    case GetAuthPacketActionDispatchTypes.GET_AUTH_PACKET_RESET: {
      return initialState;
    }
  }
  return state;
};

export default GetAuthPacketReducer;
